// extracted by mini-css-extract-plugin
export default {"catalog":"VHx4T ZdH1P","list":"i4dRQ","delimiter":"K4HeW","isInSpotlight":"dQdo0"};